/**
 * SystemCommonCodeManagementPage Component
 * 공통코드 관리 페이지 - 그룹별 공통코드 조회
 */
import React, { useEffect, useCallback } from 'react';
import Loading from '@/shared/components/feedback/Loading';
import { useSystemCommonCode } from '../hooks/useSystemCommonCode';
import { DASHBOARD_EVENTS } from '../../shared/config/system.config';
import GroupTable from './GroupTable';
import { navigateToAddPage } from '../utils/commonCodeManagementUtils';
import { LOADING_MESSAGES } from '../constants/commonCode.constants';
import '../styles/SystemCommonCodeManagementPage.css';

const SystemCommonCodeManagementPage: React.FC = () => {
    const {
        groups,
        groupsLoading,
        groupsExpanded,
        fetchGroups,
        expandedGroupCodes,
        groupCodesCache,
        groupCodesLoading,
        toggleGroupCodes,
    } = useSystemCommonCode();

    useEffect(() => {
        const handleRefresh = () => fetchGroups();
        window.addEventListener(DASHBOARD_EVENTS.COMMON_CODE_REFRESH, handleRefresh);
        return () => window.removeEventListener(DASHBOARD_EVENTS.COMMON_CODE_REFRESH, handleRefresh);
    }, [fetchGroups]);

    const handleAddClick = useCallback(() => navigateToAddPage(), []);

    return (
        <div className="common-code-management-page">
            <div className="page-header">
                <h1 className="page-title">공통코드 관리</h1>
                <button className="btn btn-primary" onClick={handleAddClick}>
                    <i className="fas fa-plus"></i>
                    공통코드 추가
                </button>
            </div>

            <div className="query-section">
                <button
                    className={`query-button ${groupsExpanded ? 'expanded' : ''}`}
                    onClick={fetchGroups}
                    disabled={groupsLoading}
                >
                    <div className="query-button-content">
                        <i className="fas fa-layer-group"></i>
                        <span>공통코드 그룹 조회</span>
                    </div>
                    <i className={`fas fa-chevron-down query-arrow ${groupsExpanded ? 'expanded' : ''}`}></i>
                </button>

                {groupsExpanded && (
                    groupsLoading ? (
                        <div className="query-loading">
                            <Loading message={LOADING_MESSAGES.GROUPS} />
                        </div>
                    ) : (
                        <>
                            <div className="result-count">
                                <i className="fas fa-list"></i>
                                총 <strong>{groups.length.toLocaleString()}개</strong> 그룹
                            </div>
                            <div className="table-container">
                                <GroupTable
                                    groups={groups}
                                    expandedGroupCodes={expandedGroupCodes}
                                    groupCodesCache={groupCodesCache}
                                    groupCodesLoading={groupCodesLoading}
                                    onToggleGroup={toggleGroupCodes}
                                />
                            </div>
                        </>
                    )
                )}
            </div>
        </div>
    );
};

export default SystemCommonCodeManagementPage;
